/**
 * Detecta series de referencia (.Ref) para badge Explorer y auto-pin de descarga.
 * Convención UDV: sufijo ".Ref" en descripción; manifest futuro: role === 'ref'.
 */

const REF_DESC_SUFFIX_RE = /\.ref\s*$/i

/**
 * @param {string|null|undefined} description
 * @returns {boolean}
 */
export function seriesDescriptionIsRef(description) {
  if (!description || typeof description !== 'string') return false
  const trimmed = description.trim()
  if (!trimmed) return false
  return REF_DESC_SUFFIX_RE.test(trimmed)
}

/**
 * @param {object} meta
 * @param {string} [meta.seriesDescription]
 * @param {string} [meta.description]
 * @param {string} [meta.role]
 * @returns {boolean}
 */
export function isRefSeries(meta = {}) {
  if (!meta || typeof meta !== 'object') return false
  const role = meta.role != null ? String(meta.role).trim().toLowerCase() : ''
  if (role === 'ref' || role === 'reference') return true
  const desc = meta.seriesDescription || meta.description || ''
  return seriesDescriptionIsRef(desc)
}

/**
 * @param {object|null} fileItem
 * @returns {boolean}
 */
export function isRefFileItem(fileItem) {
  if (!fileItem) return false
  if (fileItem.series && fileItem.series.isRef === true) return true
  if (fileItem.isRef === true) return true

  const series = fileItem.series || {}
  const seriesDescription =
    series.seriesDescription ||
    series.description ||
    fileItem.seriesDescription ||
    ''

  const role =
    series.role != null
      ? series.role
      : fileItem.role != null
        ? fileItem.role
        : null

  return isRefSeries({
    seriesDescription,
    role,
  })
}

/**
 * Marca series.isRef in-place.
 * @param {object} fileItem
 * @returns {object}
 */
export function stampIsRefOnFileItem(fileItem) {
  if (!fileItem) return fileItem
  if (!fileItem.series) fileItem.series = {}
  fileItem.series.isRef = isRefFileItem(fileItem)
  return fileItem
}

/**
 * @param {object[]} items
 * @returns {object[]}
 */
export function stampIsRefOnItems(items) {
  if (!Array.isArray(items)) return items
  items.forEach(stampIsRefOnFileItem)
  return items
}

/**
 * Índices Explorer de series .Ref (orden de seriesKeys).
 * @param {any[]} seriesKeys
 * @param {Map|object|null} seriesList
 * @returns {number[]}
 */
export function findRefSeriesIndices(seriesKeys, seriesList) {
  if (!Array.isArray(seriesKeys) || !seriesList) return []
  const getFiles =
    typeof seriesList.get === 'function'
      ? (k) => seriesList.get(k)
      : (k) => seriesList[k]

  const out = []
  for (let i = 0; i < seriesKeys.length; i++) {
    const key = seriesKeys[i]
    const files = getFiles(key)
    if (!Array.isArray(files) || files.length === 0) continue
    const sample = files.find((f) => f && f.series) || files[0]
    if (isRefFileItem(sample)) out.push(i)
  }
  return out
}

/**
 * Series Instance UID del primer file de la serie.
 * @param {object[]} files
 * @returns {string|null}
 */
export function seriesInstanceUidFromFiles(files) {
  if (!Array.isArray(files)) return null
  for (let i = 0; i < files.length; i++) {
    const f = files[i]
    if (!f) continue
    const uid =
      (f.series && f.series.seriesInstanceUID) ||
      f.seriesInstanceUID ||
      (f.series && f.series.seriesId)
    if (uid && String(uid).trim()) return String(uid).trim()
  }
  return null
}
